import { resetPassword as authResetPassword } from '@Services/Auth/AuthResetPassword';
import Catalyst from '@Services/Catalyst';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import {
  forgotPasswordDialogSetEmailReducerType,
  forgotPasswordDialogSetIsLoadingReducerType,
  forgotPasswordDialogSetResultReducerType,
  forgotPasswordDialogInitStateReducerType,
  possibleResults,
} from './ForgotPasswordDialogConstants';
import { email as emailSelector, isLoading as isLoadingSelector } from './ForgotPasswordDialogSelectors';

export function setEmail(email) {
  return {
    type: forgotPasswordDialogSetEmailReducerType,
    payload: { email },
  };
}

export function initState(updatedInitialState = {}) {
  return {
    type: forgotPasswordDialogInitStateReducerType,
    payload: {
      updatedInitialState,
    },
  };
}

export function setResult(result) {
  return {
    type: forgotPasswordDialogSetResultReducerType,
    payload: { result },
  };
}

export function setIsLoading(isLoading) {
  return {
    type: forgotPasswordDialogSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function openForgotPasswordDialog() {
  return (dispatch) => {
    dispatch(
      initState({
        email: '',
        result: null,
      })
    );
    history.push(paths.FORGOT_PASSWORD);
  };
}

export function openResetPasswordDuringAuthDialog(passwordResetEmailSent) {
  return async (dispatch) => {
    dispatch(
      initState({
        result: passwordResetEmailSent ? possibleResults.success : possibleResults.error,
      })
    );
    history.push(paths.FORGOT_PASSWORD);
  };
}

export function closeForgotPasswordDialog() {
  return () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.push(paths.LOGIN);
  };
}

export const trackAdobeAnalyticsError = (message, prefix) => {
  Catalyst.trackError(
    {
      message,
      component: 'Reset password',
    },
    prefix
  );
};

export function onEmailSubmit() {
  return async (dispatch, getState) => {
    const email = emailSelector(getState());
    const isLoading = isLoadingSelector(getState());
    if (isLoading) {
      return;
    }

    dispatch(setIsLoading(true));
    await authResetPassword(email)
      .then(() => {
        dispatch(setResult(possibleResults.success));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          trackAdobeAnalyticsError('Invalid email', 'se-');
          dispatch(setResult(possibleResults.emailInvalid));
        } else {
          trackAdobeAnalyticsError('Server error', 'se-');
          dispatch(setResult(possibleResults.error));
        }
      })
      .finally(() => {
        dispatch(setIsLoading(false));
      });
  };
}
